import config from '../config';

const trekTemplates = {
  e4e63a14f912: 'gokyo-lakes-and-gokyo-ri.e4e63a14f912.everest-region',
  e9454db30a8e: 'everest-base-camp-trek.e9454db30a8e.everest-region',
  e5947a6fc43c: 'salleri-to-everest-base-camp-trek.e5947a6fc43c.everest-region',
  e7d6353b261e: 'everest-base-camp-trek-dingboche.e7d6353b261e.everest-region',
  e8ce3b049cfe:
    'gokyo-lakes-and-everest-base-camp-trek-cho-la-circuit.e8ce3b049cfe.everest-region',
  e6b7acbf9101:
    'jiri-to-everest-base-camp-trek-classic-ebc-trek.e6b7acbf9101.everest-region',
  e3f368f3159e: 'everest-panorama-trek.e3f368f3159e.everest-region',
  e27eac156eb0: 'gokyo-lakes-with-renjo-la-trek.e27eac156eb0.everest-region',
  e21b62630f7a:
    'everest-three-passes-trek-with-everest-base-camp.e21b62630f7a.everest-region',
  e6abb9fa61b8: 'upper-mustang-trek.e6abb9fa61b8.upper-mustang-region',
  e7a173a948b3: 'annapurna-base-camp-trek.e7a173a948b3.annapurna-region',
  e1b98d782329: 'annapurna-seven-passes-trek.e1b98d782329.annapurna-region',
  e3aa3048d02f: 'langtang-valley-trek.e3aa3048d02f.langtang-region',
  e1174a3ca7b4: 'annapurna-circuit-trek.e1174a3ca7b4.annapurna-region',
  e8049b639af5: 'gosainkunda-trek.e8049b639af5.langtang-region',
  e01d885936d7: 'jomsom-trek-via-lubra.e01d885936d7.annapurna-region',
  e103b48ac556: 'manaslu-circuit.e103b48ac556.manaslu-region',
  e4cd51feaa0d: 'tilicho-trek.e4cd51feaa0d.annapurna-region',
  e5f4909a9b50: 'mardi-himal-trek.e5f4909a9b50.annapurna-region',
};

export default function generateCanonicalUrl(id) {
  return `${config.appUrl}/treks/${trekTemplates[id]}`;
}



// WEBPACK FOOTER //
// ./src/constants/trekTemplate.js